import Extend from 'flarum/common/extenders';
import User from 'flarum/common/models/User';
export default [new Extend.Model(User) //
.attribute('canViewSocialProfile').attribute('canEditSocialProfile').attribute('socialButtons', str => JSON.parse(str || '[]'))];